/**
 * 
 */
import { TerritoryShort } from './territoryShort.model';
import { PlaceEquipment } from './placeEquipment.model';
export class Territory extends TerritoryShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public equipment: PlaceEquipment[]; /*Оснащение*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.equipment = [];
        if (json.equipment) {
          for (const i in json.equipment) {
            if ( json.equipment.hasOwnProperty( i ) ) {
                this.equipment.push(new PlaceEquipment(json.equipment[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
